import { projectRequest } from 'store/utils/request';

export default async params => {
  try {
    return await projectRequest.get('/search/', {
      params,
    });
  } catch (error) {
    throw error;
  }
};
